import { j as s } from "../../../node_modules/react/jsx-runtime.js";
import { forwardRef as X, useState as W, useRef as $, useCallback as y, useEffect as H, useMemo as P, cloneElement as Y } from "react";
import { createPortal as Z } from "react-dom";
import { clsx as C } from "../../../node_modules/clsx/dist/clsx.m.js";
import { Typography as K } from "../../atoms/Typography/Typography.js";
import { FeaturedIcon as ss } from "../../atoms/FeaturedIcon/FeaturedIcon.js";
import e from "./SideDrawer.module.scss.js";
import is from "../../atoms/CompactButton/CompactButton.js";
import _ from "../../../node_modules/lodash/isEmpty.js";
import ts from "../../atoms/LinkButton/LinkButton.js";
import ls from "../../atoms/Checkbox/Checkbox.js";
import m from "../../atoms/Button/Button.js";
import ns from "../Dropdown/Dropdown.js";
import cs from "../../atoms/ListItem/ListItem.js";
import I from "../../atoms/Tooltip/Tooltip.js";
const ys = X(
  ({
    size: w = "default",
    active: x,
    onClose: j,
    header: i,
    children: G,
    footer: t,
    trigger: d,
    disableCloseOut: D = !1,
    testId: J,
    zIndex: Q
  }) => {
    var O, h, R, z;
    const [b, k] = W(x), [N, T] = W(!1), p = $(null), A = $(!0), f = document.body.getAttribute("dir") === "rtl", r = y(() => {
      T(!0), setTimeout(() => {
        k(!1), T(!1), j == null || j();
      }, 300);
    }, [j]), F = y(() => {
      var c, l;
      D ? ((l = (c = p.current) == null ? void 0 : c.classList) == null || l.add("animate-shake"), setTimeout(() => {
        var n;
        (n = p.current) == null || n.classList.remove("animate-shake");
      }, 100)) : r();
    }, [D, r]), L = y(() => {
      setTimeout(() => {
        var c, l, n, a;
        f ? (l = (c = p.current) == null ? void 0 : c.classList) == null || l.remove(e.sidebarMoveInLeft) : (a = (n = p.current) == null ? void 0 : n.classList) == null || a.remove(e.sidebarMoveInRight);
      }, 300), k((c) => !c);
    }, []);
    H(() => {
      x ? k(x) : (A.current || r(), A.current = !1);
    }, [x]), H(() => {
      var n, a, u, o, E, g, M;
      const c = document.querySelectorAll(`[class*=${e.sideDrawer}]`), l = document.querySelectorAll(`[class*=${e.outSideDrawer}]`);
      c.length > 1 ? ((u = (a = (n = c == null ? void 0 : c[0]) == null ? void 0 : n.classList) == null ? void 0 : a.add) == null || u.call(a, e.sideDrawerStacked), (o = l == null ? void 0 : l.forEach) == null || o.call(
        l,
        (es, S) => {
          var q, v, B;
          return S > 0 && ((B = (v = (q = l == null ? void 0 : l[S]) == null ? void 0 : q.classList) == null ? void 0 : v.add) == null ? void 0 : B.call(v, e.hiddenOutSide));
        }
      )) : c.length < 2 && ((M = (g = (E = c == null ? void 0 : c[0]) == null ? void 0 : E.classList) == null ? void 0 : g.remove) == null || M.call(g, e.sideDrawerStacked));
    });
    const U = P(
      () => d && Y(d, {
        onClick: (c) => {
          var l, n;
          (n = (l = d.props).onClick) == null || n.call(l, c), L();
        }
      }),
      [d, L]
    ), V = P(() => {
      if (i != null && i.actions) {
        const c = i.actions.length > 3 ? i.actions.slice(0, 2) : i.actions, l = i.actions.length > 3 ? i.actions.slice(2) : [];
        return /* @__PURE__ */ s.jsxs("div", { className: e.drawerActions, children: [
          c.map((n, a) => /* @__PURE__ */ s.jsx(s.Fragment, { children: n.tooltip ? /* @__PURE__ */ s.jsx(
            I,
            {
              placement: "bottom",
              behavior: "tooltip",
              description: n.tooltip,
              trigger: /* @__PURE__ */ s.jsx(
                m,
                {
                  ...n,
                  onClick: (u) => {
                    var o;
                    return (o = n.onClick) == null ? void 0 : o.call(n, u);
                  },
                  iconOnly: !n.label,
                  variant: "ghost",
                  color: "neutral",
                  size: "small"
                }
              )
            },
            a
          ) : /* @__PURE__ */ s.jsx(
            m,
            {
              ...n,
              onClick: (u) => {
                var o;
                return (o = n.onClick) == null ? void 0 : o.call(n, u);
              },
              iconOnly: !n.label,
              variant: "ghost",
              color: "neutral",
              size: "small"
            }
          ) })),
          l.length > 0 && /* @__PURE__ */ s.jsx(
            ns,
            {
              position: "bottom-end",
              dropDownElement: /* @__PURE__ */ s.jsx(
                m,
                {
                  iconOnly: !0,
                  size: "small",
                  leadingIcon: "dots-vertical",
                  variant: "ghost",
                  color: "neutral",
                  testId: "more-actions-button"
                }
              ),
              fitDropDown: !0,
              withPortal: !0,
              itemType: "button",
              children: l.map((n, a) => /* @__PURE__ */ s.jsx(
                cs,
                {
                  ...n,
                  text: n.label ?? "",
                  testId: `actions-menuitem-${a}`
                },
                a
              ))
            }
          )
        ] });
      }
      return null;
    }, [i == null ? void 0 : i.actions]);
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      d && /* @__PURE__ */ s.jsx("div", { className: "w-fit", children: U }),
      b && /* @__PURE__ */ s.jsx(s.Fragment, { children: Z(
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx(
            "div",
            {
              className: C(e.outSideDrawer, {
                [e.sideDrawerOutSideFadeOut]: N
              }),
              onClick: F,
              onKeyDown: F,
              role: "button",
              tabIndex: 0
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: C(e.sideDrawer, {
                "w-[400px] max-w-[400px]": w === "narrow",
                "w-[500px] max-w-[500px]": w === "default",
                "w-[600px] max-w-[600px]": w === "wide",
                [e.sideDrawerMoveOut]: N,
                [e.sidebarMoveInRight]: b && !f,
                [e.sidebarMoveInLeft]: b && f
              }),
              style: { zIndex: Q },
              "data-testid": J,
              ref: p,
              children: [
                ((i == null ? void 0 : i.title) || (i == null ? void 0 : i.description) || (i == null ? void 0 : i.leadingSpace) || (i == null ? void 0 : i.withClose)) && /* @__PURE__ */ s.jsxs("div", { className: e.drawerHeader, children: [
                  /* @__PURE__ */ s.jsxs("div", { className: "flex gap-200 w-full", children: [
                    ((O = i.leadingSpace) == null ? void 0 : O.icon) && !((h = i.leadingSpace) != null && h.custom) && /* @__PURE__ */ s.jsx("div", { className: "h-fit rounded-medium shadow-ambient", children: /* @__PURE__ */ s.jsx(
                      ss,
                      {
                        iconName: i.leadingSpace.icon,
                        colorType: "neutral",
                        variant: "outline",
                        size: "md",
                        rounded: !1
                      }
                    ) }),
                    ((R = i.leadingSpace) == null ? void 0 : R.custom) && /* @__PURE__ */ s.jsx(s.Fragment, { children: (z = i.leadingSpace) == null ? void 0 : z.custom }),
                    /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-100 justify-center pr-150", children: [
                      i.title && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          text: i.title,
                          variant: "interface/strong/ml",
                          testId: i.titleTestId
                        }
                      ),
                      i.description && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          text: i.description,
                          className: e.drawerHeaderDescription,
                          variant: "body-new/regular",
                          testId: i.descriptionTestId,
                          textColor: "color/fg/light"
                        }
                      )
                    ] })
                  ] }),
                  i.withClose && !i.actions ? /* @__PURE__ */ s.jsx(
                    is,
                    {
                      icon: "x",
                      variant: "ghost",
                      testId: i.closeIconTestId,
                      onClick: r
                    }
                  ) : V
                ] }),
                /* @__PURE__ */ s.jsx("div", { className: e.contentContainer, children: G }),
                ((t == null ? void 0 : t.submit) || (t == null ? void 0 : t.cancel) || (t == null ? void 0 : t.checkbox) || (t == null ? void 0 : t.link)) && /* @__PURE__ */ s.jsxs("div", { className: e.drawerFooter, children: [
                  !t.fullWidth && /* @__PURE__ */ s.jsxs("div", { className: e.footer3rdActions, children: [
                    !_(t.link) && /* @__PURE__ */ s.jsx(ts, { ...t.link }),
                    !_(t.checkbox) && /* @__PURE__ */ s.jsx(
                      ls,
                      {
                        ...t.checkbox,
                        onChange: (c) => {
                          var l, n;
                          return (n = (l = t.checkbox) == null ? void 0 : l.onChange) == null ? void 0 : n.call(l, c.target.checked);
                        }
                      }
                    )
                  ] }),
                  /* @__PURE__ */ s.jsxs(
                    "div",
                    {
                      className: C(
                        e.mainFooterActions,
                        t.fullWidth && e.footerFullWidth
                      ),
                      children: [
                        t.cancel && /* @__PURE__ */ s.jsx(s.Fragment, { children: t.cancel.tooltip ? /* @__PURE__ */ s.jsx(
                          I,
                          {
                            placement: "top",
                            behavior: "tooltip",
                            description: t.cancel.tooltip,
                            trigger: /* @__PURE__ */ s.jsx(
                              m,
                              {
                                ...t.cancel,
                                variant: "outlined",
                                color: "neutral",
                                size: "medium",
                                onClick: (c) => {
                                  var l;
                                  if ((l = t.cancel) != null && l.onClick) return t.cancel.onClick(c);
                                  r();
                                }
                              }
                            )
                          }
                        ) : /* @__PURE__ */ s.jsx(
                          m,
                          {
                            ...t.cancel,
                            variant: "outlined",
                            color: "neutral",
                            size: "medium",
                            onClick: (c) => {
                              var l;
                              if ((l = t.cancel) != null && l.onClick) return t.cancel.onClick(c);
                              r();
                            }
                          }
                        ) }),
                        t.submit && /* @__PURE__ */ s.jsx(s.Fragment, { children: t.submit.tooltip ? /* @__PURE__ */ s.jsx(
                          I,
                          {
                            placement: "top",
                            behavior: "tooltip",
                            description: t.submit.tooltip,
                            trigger: /* @__PURE__ */ s.jsx(
                              m,
                              {
                                ...t.submit,
                                variant: "filled",
                                color: "primary",
                                size: "medium"
                              }
                            )
                          }
                        ) : /* @__PURE__ */ s.jsx(
                          m,
                          {
                            ...t.submit,
                            variant: "filled",
                            color: "primary",
                            size: "medium"
                          }
                        ) })
                      ]
                    }
                  )
                ] })
              ]
            }
          )
        ] }),
        document.body
      ) })
    ] });
  }
);
export {
  ys as default
};
//# sourceMappingURL=SideDrawer.js.map
